import axios from "axios";
import {
  FETCH_VENTAS_REQUEST,
  FETCH_VENTAS_SUCCESS,
  FETCH_VENTAS_FAILURE,
} from "./types";
import { PATH } from "../../utils";

const api = axios.create({
  baseURL: PATH,
  headers: { "Content-Type": "application/json" },
});

const authHeader = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const actionVentasGet = (params = {}) => async (dispatch) => {
  dispatch({ type: FETCH_VENTAS_REQUEST });
  try {
    const cleanParams = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
    );
    const res = await api.get("/ventas", { headers: authHeader(), params: cleanParams });
    const items = Array.isArray(res.data) ? res.data : res.data?.items ?? [];
    dispatch({ type: FETCH_VENTAS_SUCCESS, payload: items });
  } catch (err) {
    const msg = err?.response?.data?.detail || err.message || "Error al cargar ventas";
    dispatch({ type: FETCH_VENTAS_FAILURE, payload: { error: msg } });
  }
};

export const apiVentasInstance = api;
export { authHeader as authHeaderVentas };
